import axios from "axios";
import { del, get, post, patch,  put } from "./document_requests_api_helper";
import * as url from "./document_requests_url_helper";





// Get features
export const getDocumentRequests = () => get(url.GET_DOCUMENT_REQUESTS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewDocumentRequest = documentRequest => post(url.ADD_NEW_DOCUMENT_REQUEST, documentRequest, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateDocumentRequest = documentRequest => patch(`${url.UPDATE_DOCUMENT_REQUEST}/${documentRequest.id}`,  documentRequest);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteDocumentRequest = documentRequest => del(`${url.DELETE_DOCUMENT_REQUEST}/${documentRequest.id}`);







export {
  //getLoggedInUser,
  
  
};
